// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"221":"b91cfcb8","1758":"b91cfcb8","2872":"07c7b97e","5769":"b91cfcb8","6433":"60d660d3","6804":"b91cfcb8","9948":"60d660d3"}[chunkId] + ".chunk.css";
};